/* eslint-disable no-underscore-dangle */
const log = require('log').create('styles') // eslint-disable-line

// auto-insert isomorphic styles for backbone/marionette views & objects

// this function manages the this._stylesToInsert array during view/object instantiation
function addStyles(styles) {
    if (! styles) return

    // if an array of styles objects is passed in, loop through and call
    // addStyles for each one
    if (Array.isArray(styles)) {
        styles.forEach(style => {
            addStyles.call(this, style)
        })
        return
    }

    // ensure that this._stylesToInsert is an array
    if (! Array.isArray(this._stylesToInsert)) this._stylesToInsert = []

    // add the new styles to the array
    this._stylesToInsert.push(styles)
}

function insertStyles() {
    if (this._stylesToInsert) {
        this._stylesToRemove = []
        this._stylesToInsert.forEach((style) => {
            if (style._insertCss) {
                const removeStyle = style._insertCss()
                this._stylesToRemove.push(removeStyle)
                if (style.scope && this.$el) {
                    this.$el.addClass(style.scope)
                }
            }
        })
    }
}

function removeStyles() {
    if (this._stylesToRemove) {
        setTimeout(() => {
            this._stylesToRemove.forEach((removeStyle) => removeStyle())
        }, 1000)
    }
}

module.exports = {
    addStyles,
    insertStyles,
    removeStyles,
}
